export default __webpack_public_path__ + "static/media/it-78.8117d85f.svg";